import i18n from 'react-intl-universal';

export const noOptionsMessage = ({ inputValue }) => {
  if (inputValue === '') {
    return i18n.get('app.commons.label.startSearch');
  }
  return i18n.get('app.commons.label.noResults');
};

export const loadingMessage = () => {
  return i18n.get('app.commons.label.loading');
};
